import {  useState } from "react";
import { useTranslation } from "react-i18next";

import CreateRecordButtonLayout from "../layout/CreateRecordButtonLayout";
import EguLabDataSheetDetailCreateDialog from "../dialogTypes/EguLabDataSheetDetailCreateDialog";


function EguLabDataSheetDetailCreateButton(props) {

    const { t } = useTranslation();

    const { id, schema, refresh, selectMst, onSuccess, createButtonName, customizeErrorMsgCallback, ...others } = props;

    const [open, setOpen] = useState(false);

    const onOpen = () => {

        setOpen(true);

    };

    const onClose = () => {

        setOpen(false);

    };

    const onCreateSuccess = (msg) => {

        if (onSuccess) {

            onSuccess(msg);

        }

        refresh.refresh();

    };

    return (

        <>
            <CreateRecordButtonLayout id={id + "create-button"} onClick={onOpen} createButtonName={createButtonName} {...others} />
            <EguLabDataSheetDetailCreateDialog
                id={id + "create-dialog"}
                mode="create"
                refresh={refresh}
                formId={id + "create-form"}
                title={schema ? t(`dialog.title.${schema.name}.create`) : ""}
                schema={schema}
                initialData={undefined}
                open={open}
                selectMst={selectMst}
                onClose={onClose}
                onSuccess={onCreateSuccess}
                customizeErrorMsgCallback={customizeErrorMsgCallback}
            />
        </>

    );
}

export default EguLabDataSheetDetailCreateButton;

